import axios from 'axios'
import Qs from 'qs'
import { moduleConfig } from '@/modules/core'
export default class ApiCore {
  constructor(path, store) {
    this._config = moduleConfig()
    this._path = path
    this._store = store
  }

  _request(o) {
    let url = `${this._config.shared.apiServerUrl}/${this._path}`
    if (o.action) {
      url = `${url}${o.action ? '/' + o.action : ''}`
    }
    o.headers = o.headers || {}
    const req = {
      url,
      method: o.method,
      params: o.params,
      paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }),
      data: o.body,
      headers: {
        ...o.headers,
        'Content-Type': 'application/json'
      },
      onUploadProgress: function () { },

      onDownloadProgress: function () { }
    }

    const account = this._store.state.$account

    if (account) {
      req.headers.Authorization = 'Bearer ' + account.accessToken
    }
    return axios(req)
      .then(res => {
        return res.data
      })
      .catch(err => {
        if (err.message === 'Network Error') {
          this._store.commit('SET_OFFLINE')
        }
        else if (err.response.status == 403 || err.response.status == 406) {
          this._store.commit('LOGOUT')
        }
        throw err.response
      })
  }
}
